import * as tslib_1 from "tslib";
import { InputField } from '../input_field';
var ReferenceField = /** @class */ (function (_super) {
    tslib_1.__extends(ReferenceField, _super);
    function ReferenceField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'dataSource';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    ReferenceField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "ReferenceField",
            "dataSource": this.dataSource
        });
    };
    ReferenceField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ReferenceField;
}(InputField));
export { ReferenceField };
//# sourceMappingURL=reference_field.js.map